<template>
  <div>
    <div class="quiz-content">
      <h2>What is your age?</h2>
    </div>
    <QuizAgeSelect
        :options="quizQuestions"
        @optChanged="onOptionChanged"
    />
    <div class="button-content">
      <button class='btn-prev w-btn us-btn-style_2' @click="prevQuiz">
        <span class="w-btn-label">&larr; Prev</span>
      </button>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';
import QuizAgeSelect from "./QuizAgeSelect";
import swal from 'sweetalert';

export default {
  name: 'QuizAge',
  components: {
    QuizAgeSelect
  },

  data() {
    return {
      age: '',
    };
  },

  computed: {
    ...mapGetters( [
      'getGender',
    ] ),
    quizQuestions() {
      if ( this.getGender === "male" ) {
        return [
          { option: "18 - 39 years", src: "person.png" },
          { option: "40 - 49 years", src: "person.png" },
          { option: "50+ years", src: "person.png" },
        ];
      } else {
        return [
          { option: "18 - 30 years", src: "person.png" },
          { option: "31 - 39 years", src: "person.png" },
          { option: "40 - 49 years", src: "person.png" },
          { option: "50+ years", src: "person.png" },
        ];
      }
    },
  },

  methods: {
    ...mapMutations( [
      'setStep',
      'setAge',
      'setCostInputed',
    ] ),

    prevQuiz() {
      this.setStep( 0 );

      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    nextQuiz() {
      if ( this.age === '' ) {
        swal( "Warning!", "Please select your age.", "warning" );
        return;
      }
      this.setStep( 2 );
      this.setCostInputed( 2 );
      this.setAge( this.age );

      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    onOptionChanged( option ) {
      this.age = option;
      this.nextQuiz();
    },
  }
}
</script>